<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      top="8vh"
      append-to-body
      title="选择供应商"
      width="800px">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="supplierInfoes"
        @select="selectSupplier"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="编号" prop="no">
            <el-input v-model.trim="filter.no" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model.trim="filter.name" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          no: "",
          name: "",
        },
        columns: [
          {
            title: "编号",
            key: "no",
            width: 120,
            align: "center",
          },
          {
            title: "名称",
            key: "name",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectSupplier(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
